import { render, staticRenderFns } from "./CategoryEmptyResults.vue?vue&type=template&id=534494c2&scoped=true&"
import script from "./CategoryEmptyResults.vue?vue&type=script&lang=ts&"
export * from "./CategoryEmptyResults.vue?vue&type=script&lang=ts&"
import style0 from "./CategoryEmptyResults.vue?vue&type=style&index=0&id=534494c2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "534494c2",
  null
  
)

export default component.exports